/**
 * Kempower / IoT alerts may be plain strings or API objects
 * ({ title, message, errorCode, errors, payload, ... }).
 */

function addError(errors, value) {
  if (value == null) return;
  const text = String(value).trim();
  if (text) errors.push(text);
}

function collectAlertErrors(alert) {
  if (alert == null) return [];
  if (typeof alert === 'string') return [alert.trim()].filter(Boolean);
  if (typeof alert === 'number' || typeof alert === 'boolean') return [String(alert)];

  if (typeof alert !== 'object') return [];

  const specific = [];

  if (Array.isArray(alert.payload)) {
    alert.payload.forEach((entry) => {
      if (Array.isArray(entry?.errors)) {
        entry.errors.forEach((error) => addError(specific, error));
      }
    });
  }

  if (Array.isArray(alert.errors)) {
    alert.errors.forEach((error) => addError(specific, error));
  }

  if (specific.length > 0) {
    return [...new Set(specific)];
  }

  const fallback = [];
  addError(fallback, alert.errorCode);
  addError(fallback, alert.code);
  if (Array.isArray(alert.metadata?.payload)) {
    alert.metadata.payload.forEach((entry) => {
      if (Array.isArray(entry?.errors)) {
        entry.errors.forEach((error) => addError(fallback, error));
      }
    });
  }
  addError(fallback, alert.type);
  addError(fallback, alert.alertType);
  addError(fallback, alert.title);
  addError(fallback, alert.name);

  return [...new Set(fallback)];
}

export function getAlertDetailMessage(alert) {
  if (alert == null || typeof alert !== 'object') return '';
  const message = alert.message || alert.description || '';
  return String(message).trim();
}

export function formatAlertText(alert) {
  const errors = collectAlertErrors(alert);
  const module =
    Array.isArray(alert?.payload) && alert.payload.length === 1
      ? alert.payload[0]?.module
      : null;

  if (errors.length > 0) {
    const errorText = errors.join(', ');
    return module ? `${module}: ${errorText}` : errorText;
  }

  if (alert == null) return '';
  if (typeof alert === 'string') return alert;
  if (typeof alert === 'number' || typeof alert === 'boolean') return String(alert);

  if (typeof alert === 'object') {
    const text =
      alert.title ||
      alert.message ||
      alert.description ||
      alert.name ||
      alert.errorCode ||
      alert.code ||
      alert.type ||
      alert.alertType;
    if (text != null && String(text).trim()) return String(text);
  }

  return 'Alert';
}
